angular.module('menu').component('userMenu', {
    templateUrl: 'js/modules/menu/components/user-menu/template.html',
    controller: 'UserMenuController',
});
